/**
 * Match a distance to a tariff band.
 *
 * Client tables use integer maxes (20, 50, …, 1000) with the next band at max+1,
 * so Google Maps distances like 1000.78 km sit in a gap. Driver tables use .99
 * maxes for the same reason. Fractional km between bands stay on the lower
 * ("up to X km") band.
 */
export function findMatchingDistanceRate(rates, distance) {
  if (!Array.isArray(rates) || rates.length === 0 || distance == null) {
    return null;
  }
  const d = Number(distance);
  if (Number.isNaN(d)) return null;

  const parsed = [];
  for (const rate of rates) {
    if (!rate) continue;
    const min = Number(rate.min_distance);
    if (Number.isNaN(min)) continue;
    const max =
      rate.max_distance === null || rate.max_distance === undefined
        ? null
        : Number(rate.max_distance);
    parsed.push({ min, max: max != null && Number.isNaN(max) ? null : max, rate });
  }

  const exact = parsed.find(({ min, max }) => d >= min && (max === null || d <= max));
  if (exact) return exact.rate;

  const below = parsed
    .filter(({ max }) => max != null && max < d)
    .sort((a, b) => b.max - a.max);
  if (!below.length) return null;
  const best = below[0];
  const nextMins = parsed.map(({ min }) => min).filter((min) => min > best.max);
  if (!nextMins.length) return null;
  return d < Math.min(...nextMins) ? best.rate : null;
}
